import {
  startOfDay, endOfDay, subDays, startOfMonth, endOfMonth, subMonths, startOfYear, format,
} from "date-fns";

export function fmtCurrency(v) {
  const n = Number(v || 0);
  return new Intl.NumberFormat("en-US", {
    style: "currency", currency: "USD", maximumFractionDigits: 0,
  }).format(n);
}

export function fmtNumber(v) {
  return new Intl.NumberFormat("en-US").format(Number(v || 0));
}

export function fmtPct(v) {
  return `${Number(v || 0).toFixed(1)}%`;
}

export function fmtDecimal(v) {
  return Number(v || 0).toFixed(1);
}

export function fmtValue(v, fmt) {
  if (fmt === "currency") return fmtCurrency(v);
  if (fmt === "percentage") return fmtPct(v);
  if (fmt === "decimal") return fmtDecimal(v);
  return fmtNumber(v);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return format(new Date(iso), "MMM d, yyyy"); } catch { return "—"; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try { return format(new Date(iso), "MMM d, yyyy h:mm a"); } catch { return "—"; }
}

export function fmtTime(iso) {
  if (!iso) return "";
  try { return format(new Date(iso), "h:mm a"); } catch { return ""; }
}

export function daysSince(iso) {
  if (!iso) return null;
  const diff = Date.now() - new Date(iso).getTime();
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

export const PRESETS = [
  { key: "today", label: "Today" },
  { key: "last7", label: "Last 7 Days" },
  { key: "last30", label: "Last 30 Days" },
  { key: "thisMonth", label: "This Month" },
  { key: "lastMonth", label: "Last Month" },
  { key: "ytd", label: "Year to Date" },
  { key: "custom", label: "Custom Range" },
];

export function presetRange(key) {
  const now = new Date();
  switch (key) {
    case "today":
      return { start: startOfDay(now), end: endOfDay(now) };
    case "last7":
      return { start: startOfDay(subDays(now, 6)), end: endOfDay(now) };
    case "last30":
      return { start: startOfDay(subDays(now, 29)), end: endOfDay(now) };
    case "thisMonth":
      return { start: startOfMonth(now), end: endOfDay(now) };
    case "lastMonth":
      return { start: startOfMonth(subMonths(now, 1)), end: endOfMonth(subMonths(now, 1)) };
    case "ytd":
      return { start: startOfYear(now), end: endOfDay(now) };
    default:
      return { start: startOfDay(subDays(now, 29)), end: endOfDay(now) };
  }
}

export function computeDelta(cur, prev, higherIsBetter = true) {
  const c = Number(cur || 0);
  const p = Number(prev || 0);
  let pct;
  if (p === 0) pct = c === 0 ? 0 : 100;
  else pct = ((c - p) / Math.abs(p)) * 100;
  const dir = c > p ? "up" : c < p ? "down" : "flat";
  const good = dir === "flat" ? "flat" : (dir === "up") === higherIsBetter ? "good" : "bad";
  return { pct: Math.abs(pct), dir, good };
}

export const LEAD_SOURCES = [
  "Google Ads", "Google Organic", "Google Business Profile", "Facebook", "Instagram",
  "Website", "Phone", "Referral", "Direct Mail", "Existing Customer", "Other",
];
